import React, { Component } from 'react';

class ShippingTermsPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="page privacy-page">
        <div className="tos-hero">
          <div className="container">
            <p className="tos-eyebrow">Jason&apos;s Wine &amp; Spirits</p>
            <h1 className="page-title">Shipping &amp; Delivery Policy</h1>
            <p className="tos-updated">
              <strong>Last Updated:</strong> 14 Dec 2025
            </p>
          </div>
        </div>

        <div className="container">
          <div className="terms-card">
            <div className="terms-section">
              <p>
                This Shipping &amp; Delivery Policy explains how orders placed through the Jason&apos;s Wine and Spirits
                website (http://jasonsliquor.com) and mobile app (the &quot;Services&quot;) are processed, shipped, and
                delivered.
              </p>
              <p>
                By placing an order with Jason&apos;s Wine and Spirits (&quot;Jason&apos;s,&quot; &quot;we,&quot;
                &quot;us,&quot; &quot;our&quot;), you agree to this Shipping &amp; Delivery Policy as well as our Terms
                of Use and Privacy Policy.
              </p>
            </div>

            <div className="terms-section">
              <h3>1. SERVICE AREA &amp; ELIGIBILITY</h3>

              <h4>1.1 Age Requirement</h4>
              <p>You must be at least 21 years old to place an order.</p>
              <p>
                The person receiving the order (whether via pickup, shipment, or delivery) must be at least 21 years old
                and present a valid, government-issued photo ID at the time of receipt.
              </p>
              <p>
                We reserve the right to refuse pickup or delivery if age or identity cannot be verified, or if we
                suspect the order is being provided to someone under 21.
              </p>

              <h4>1.2 Geographic Availability</h4>
              <p>We currently operate from our licensed premises in Los Angeles, California.</p>
              <p>We may limit shipping or delivery to certain states, zip codes, or addresses based on:</p>
              <ul>
                <li>State and local alcohol laws</li>
                <li>Carrier restrictions</li>
                <li>Our internal policies</li>
              </ul>
              <p>
                If we are unable to ship or deliver to your address, we will notify you and cancel the affected portion
                of your order with an appropriate refund.
              </p>

              <h4>1.3 No International Shipping</h4>
              <p>We do not ship or deliver outside the United States.</p>
            </div>

            <div className="terms-section">
              <h3>2. ORDER PROCESSING TIMES</h3>
              <p>
                Orders are generally processed [X–Y business days] after they are placed, excluding weekends and
                holidays.
              </p>
              <p>
                During peak periods (holidays, promotions, severe weather, etc.), processing times may be longer.
              </p>
              <p>Orders placed after our daily cutoff time may be processed on the next business day.</p>
              <p>
                <strong>📝 Customize:</strong> Replace [X–Y business days] with your actual handling time (e.g., 1–2
                business days).
              </p>
            </div>

            <div className="terms-section">
              <h3>3. SHIPPING METHODS &amp; DELIVERY OPTIONS</h3>
              <p>Depending on your location and our current offerings, you may see one or more of the following options at checkout:</p>

              <h4>3.1 In-Store Pickup</h4>
              <p>You will receive a notification when your order is ready for pickup.</p>
              <p>You (or the designated recipient) must bring:</p>
              <ul>
                <li>A valid government-issued photo ID showing age 21+</li>
                <li>The order confirmation number</li>
              </ul>
              <p>
                Orders not picked up within [X] days may be canceled at our discretion, and a restocking fee may apply
                (see Section 6).
              </p>

              <h4>3.2 Local Delivery (Where Available)</h4>
              <p>Local delivery is available only within certain areas. Eligible addresses will be shown at checkout.</p>
              <p>
                Delivery windows may be estimated, but are not guaranteed and may be affected by traffic, weather, or
                other factors.
              </p>
              <p>
                The recipient must be available at the delivery address during the delivery window, with a valid ID
                (21+).
              </p>
              <p>
                If the recipient is unavailable, cannot provide acceptable ID, appears intoxicated, or if the delivery
                would otherwise be unsafe or unlawful, the delivery may be refused and treated as a failed delivery (see
                Section 6).
              </p>

              <h4>3.3 Shipping via Carrier</h4>
              <p>For orders shipped via third-party carriers (e.g., FedEx, UPS, or other partners):</p>
              <ul>
                <li>An adult signature (21+) is required at delivery.</li>
                <li>Carriers may make one or more attempts; if delivery fails, the package may be returned to us.</li>
                <li>
                  We are not responsible for carrier delays, missed delivery windows, or conditions beyond our control
                  once the package has been handed to the carrier.
                </li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>4. SHIPPING RATES &amp; FEES</h3>
              <p>
                Shipping, delivery, and/or service fees will be displayed at checkout based on:
              </p>
              <ul>
                <li>Order size and weight</li>
                <li>Delivery method</li>
                <li>Delivery/shipping distance</li>
                <li>Applicable promotions or discounts</li>
              </ul>
              <p>
                All fees are subject to change without notice, but any changes will not affect orders already placed.
              </p>
            </div>

            <div className="terms-section">
              <h3>5. ORDER CHANGES &amp; CANCELLATIONS</h3>

              <h4>5.1 Before Processing</h4>
              <p>
                If you need to change or cancel your order, please contact us at{' '}
                <a href="mailto:order@jasonsliquor.com">order@jasonsliquor.com</a> or call (213) 485-9463 as soon
                as possible.
              </p>
              <p>
                We will make reasonable efforts to accommodate your request before your order is processed or handed off
                for shipment/delivery, but cannot guarantee changes or cancellations once processing has begun.
              </p>

              <h4>5.2 After Processing</h4>
              <p>
                Once an order has been prepared, shipped, or is out for delivery, changes and cancellations may no
                longer be possible.
              </p>
              <p>
                If a cancellation is allowed at that stage, a restocking fee may apply (see Section 6).
              </p>
            </div>

            <div className="terms-section">
              <h3>6. FAILED DELIVERIES, REFUSED ORDERS &amp; RESTOCKING FEE</h3>
              <p>If an order cannot be completed for reasons outside of our control, including but not limited to:</p>
              <ul>
                <li>Recipient is not available at the delivery address</li>
                <li>Recipient fails to provide acceptable proof of age or identity (21+)</li>
                <li>Recipient appears intoxicated</li>
                <li>Delivery is refused or unsafe/unlawful in our reasonable judgment</li>
                <li>Incorrect or incomplete delivery address provided by customer</li>
                <li>Order is not picked up within the specified time</li>
              </ul>
              <p>then:</p>
              <ul>
                <li>The order may be returned to our store and treated as a canceled order; and</li>
                <li>
                  A non-refundable restocking fee of twenty dollars ($20.00) may be charged, as described in our Terms of
                  Use.
                </li>
              </ul>
              <p>
                Any eligible refund (if applicable) may be reduced by the restocking fee and any shipping or delivery
                costs we have incurred.
              </p>
            </div>

            <div className="terms-section">
              <h3>7. WEATHER &amp; TEMPERATURE SENSITIVE SHIPMENTS</h3>
              <p>In extreme weather (heat or cold), we may:</p>
              <ul>
                <li>Delay shipments</li>
                <li>Recommend alternate shipping options</li>
                <li>Notify you of possible risks to product quality</li>
              </ul>
              <p>
                We are not responsible for weather-related damage if you choose to proceed with shipment against our
                recommendation or after being informed of the risks.
              </p>
            </div>

            <div className="terms-section">
              <h3>8. TITLE &amp; RISK OF LOSS</h3>
              <p>
                In accordance with our Terms of Use, title to, and ownership of, all products passes to you at our
                licensed premises in California at the time your order is processed and accepted.
              </p>
              <p>
                After title passes, you are responsible for the shipment, and risk of loss transfers to you. We arrange
                shipping or delivery on your behalf.
              </p>
            </div>

            <div className="terms-section">
              <h3>9. CONTACT INFORMATION FOR SHIPPING QUESTIONS</h3>
              <p>If you have any questions about shipping, delivery, or the status of your order, please contact:</p>
              <p className="address-block">
                Jason&apos;s Wine and Spirits<br />
                Email: <a href="mailto:order@jasonsliquor.com">order@jasonsliquor.com</a><br />
                Phone: (213) 485-9463<br />
                Address: 828 S. Main Street, Los Angeles, CA 90014
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ShippingTermsPage;



// WEBPACK FOOTER //
// ./src/containers/tos/ShippingTermsPage.js